<template>
  <!-- eslint-disable -->
  <a
    class="bottom-banner m-btn"
    href="https://schooluniversity.ru/web-psychologies?utm_source=SiteBanner&utm_medium=site&utm_campaign={campaign_id}&utm_term=баннер_главная&marketer=dvk&produkt=67018269&utm_gen=3 "
    target="_blank"
  />
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: 'BottomBannerOnlyImage',
};
</script>

<style lang="scss" scoped>
.bottom-banner {
  display: block;
  position: relative;
  width: 100%;
  height: calc(var(--scale) * 60);
  background-image: url("/v2/global/banner-only-image/banner-bg.webp");
  background-position: center;
  background-size: cover;
  overflow: hidden;
  outline: none;

  @include media-down($size-tablet) {
    background-image: url("/v2/global/banner-only-image/banner-bg-tablet.webp");
    height: calc(var(--scale) * 50);
  }

  @include media-down($size-mobile) {
    background-image: url("/v2/global/banner-only-image/banner-bg-mob.webp");
  }
}
</style>
